import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { makeStyles } from '@material-ui/core/styles';
//import AmplifyWrapper from './service/auth.service';
import { Redirect, Route, Link, BrowserRouter as Router } from 'react-router-dom';
import Landing from './modules/pages/landing/Landing';
import Dashboard from './modules/pages/dashboard/Dashboard';
import SignIn from './modules/pages/sign-in/SignIn';
import SignUp from './modules/pages/sign-up/SignUp';
import ResetPassword from './modules/pages/reset-password/ResetPassword';
import ConfirmSignUp from './modules/pages/confirm-sign-up/ConfirmSignUp';
import RequestResetPassword from './modules/pages/request-reset-password/RequestResetPassword';
import Settings from './modules/pages/settings/Settings';
//import { Hub } from 'aws-amplify';
import SettingsIcon from '@material-ui/icons/Settings';
import NotificationsIcon from '@material-ui/icons/SettingsPower';
import LanguageToggle from './modules/core/language-toggle/LanguageToggle';
import styles from './modules/core/user-menu/UserMenu.scss';
import { logout } from './actions/logout-actions';
import { initializeApplication } from './actions/initialize-application-actions';
//import { useTranslation } from 'react-i18next';
//import UserMenu from './modules/core/user-menu/UserMenu';

const useMountEffect = cb => useEffect(cb, []);
//
//const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
	grow: {
		flexGrow: 1
	},
	root: {
		display: 'flex'
	},
	drawer: {
		[theme.breakpoints.up('sm')]: {
			//width: drawerWidth,
			flexShrink: 0
		}
	},
	appBar: {
		[theme.breakpoints.up('sm')]: {
			//width: `calc(100% - ${drawerWidth}px)`
			//marginLeft: drawerWidth
		}
	},
	menuButton: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			//display: 'none'
		}
	},
	toolbar: theme.mixins.toolbar,
	drawerPaper: {
		//width: drawerWidth
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	}
}));

function App(props) {
	//
	const classes = useStyles();
	const publicMenuItems = [{ label: 'Dashboard', to: '/dashboard' }, { label: 'Settings', to: '/settings' }];
	const securedMenuItems = [
		{ label: 'Landing', to: '/' },
		{ label: 'Sign in', to: '/signin' },
		{ label: 'Sign up', to: '/signup' },
		{ label: 'Confirm sign up', to: '/confirm-signup' },
		{ label: 'Request password reset', to: '/request-reset-password' },
		{ label: 'Reset password', to: '/reset-password' }
	];

	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [userMenuVisible, setUserMenuVisible] = React.useState(false);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

	useMountEffect(
		() => {
			props.initializeApplication();
		},
		[props]
	);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};
	//
	const handleMobileMenuClose = () => {
		setUserMenuVisible(false);
		setMobileMoreAnchorEl(null);
	};
	const handleMobileMenuOpen = event => {
		setMobileMoreAnchorEl(event.currentTarget);
		setUserMenuVisible(true);
	};

	/**
     * 
     */
	/* const onSettingsClick = () => {
		alert('todo');
	}; */

	/**
     * 
     */
	const onLogoutClick = () => {
		props.logout();
	};

	/**
     * 
     */
	const userMenu = mobileMoreAnchorEl
		? <Menu
				className={styles.menu}
				onClick={props.onClick}
				id={123}
				open={userMenuVisible}
				anchorEl={mobileMoreAnchorEl}
				onClose={handleMobileMenuClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				keepMounted
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
				<MenuItem>
					<SettingsIcon />
					<Link to={'/settings'}> Settings</Link>
				</MenuItem>

				<MenuItem onClick={onLogoutClick.bind(this)}>
					<NotificationsIcon />
					Sign out
				</MenuItem>
				<div className="languageToggleContainer">
					<LanguageToggle />
				</div>
			</Menu>
		: null;

	/**
     * 
     * @param {*} itm 
     * @param {*} index 
     */
	const renderDrawerMenu = (itm, index) => {
		return (
			<ListItem button key={itm.label}>
				<ListItemIcon>
					{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
				</ListItemIcon>
				<Link to={itm.to}>
					<ListItemText primary={itm.label} />
				</Link>
			</ListItem>
		);
	};

	/**
     * 
     */
	const drawerMenu = (
		<div>
			<div className="toolbar" />
			<Divider />
			<h1>Protected</h1>
			<List>
				{publicMenuItems.map((itm, index) => renderDrawerMenu(itm, index))}
			</List>
			<Divider />
			<h1>Public</h1>
			<List>
				{securedMenuItems.map((itm, index) => renderDrawerMenu(itm, index))}
			</List>
		</div>
	);

	/**
     * 
     */
	const drawer = (
		<nav className="drawer">
			{/* <Hidden smUp implementation="css">
						<Drawer
							container={container}
							variant="temporary"
							anchor={theme.direction === 'rtl' ? 'right' : 'left'}
							open={mobileOpen}
							onClose={handleDrawerToggle}
							classes={{
								paper: classes.drawerPaper
							}}
							ModalProps={{
								keepMounted: true // Better open performance on mobile.
							}}>
							{drawerMenu}
						</Drawer>
					</Hidden> */}
			<Hidden xsDown implementation="css">
				<Drawer
					classes={{
						paper: classes.drawerPaper
					}}
					onClose={handleDrawerToggle}
					variant="temporary"
					open={mobileOpen}>
					{drawerMenu}
				</Drawer>
			</Hidden>
		</nav>
	);

	/**
     * 
     */
	const appBar = (
		<AppBar position="fixed" className="appBar">
			<Toolbar>
				<IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} className="menuButton">
					<MenuIcon />
				</IconButton>
				<Typography variant="h6" noWrap>
					Platform X
				</Typography>
				<div className={classes.grow} />
				<div>
					<IconButton edge="end" aria-label="account of current user" aria-haspopup="true" color="inherit" onClick={handleMobileMenuOpen}>
						<AccountCircle />
					</IconButton>
				</div>
			</Toolbar>
		</AppBar>
	);

	/**
     * 
     */
	const application =
		props.appReady !== true
			? <div className="container">Loading...</div>
			: <div className="root">
					<Router>
						{/* <CssBaseline /> */}
						{props.isAuthenticated === true ? appBar : null}
						{props.isAuthenticated === true ? drawer : null}
						{props.isAuthenticated === true ? userMenu : null}
						<main>
							<PublicRoute exact path="/" component={Landing} isAuthenticated={props.isAuthenticated} />
							<PublicRoute path="/signin" component={SignIn} isAuthenticated={props.isAuthenticated} />
							<PublicRoute path="/signup" component={SignUp} isAuthenticated={props.isAuthenticated} />
							<PublicRoute path="/reset-password" component={ResetPassword} isAuthenticated={props.isAuthenticated} />
							<PublicRoute path="/confirm-signup" component={ConfirmSignUp} isAuthenticated={props.isAuthenticated} />
							<PublicRoute path="/request-reset-password" component={RequestResetPassword} isAuthenticated={props.isAuthenticated} />

							<PrivateRoute path="/dashboard" component={Dashboard} isAuthenticated={props.isAuthenticated} />
							<PrivateRoute path="/settings" component={Settings} isAuthenticated={props.isAuthenticated} />
						</main>
					</Router>
				</div>;

	//
	return (
		<div>
			{application}
		</div>
	);
}

/**
 * 
 */
App.propTypes = {
	container: PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element)
};

/**
 * 
 * @param {*} param0 
 */
const PublicRoute = ({ component: Component, ...rest }) => {
	const { isAuthenticated } = rest;
	return <Route {...rest} render={props => (isAuthenticated !== true ? <Component {...props} /> : <Redirect to="/dashboard" />)} />;
};

/**
 * 
 * @param {*} param0 
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
	const { isAuthenticated } = rest;
	return <Route {...rest} render={props => (isAuthenticated ? <Component {...props} /> : <Redirect to="/" />)} />;
};

/**
 * 
 * @param {*} state 
 */
const mapStateToProps = state => {
	return {
		appReady: state.appReady,
		isLoggedOut: state.logout.isLoggedOut,
		isAuthenticated: state.user.isAuthenticated
	};
};

/**
 * 
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
	return {
		initializeApplication: () => dispatch(initializeApplication()),
		logout: () => dispatch(logout())
	};
};

/**
 * 
 */
export default connect(mapStateToProps, mapDispatchToProps)(App);
